/** AppErrorBoundary —— 应用顶层错误边界。
 *  没有 boundary 时，任意渲染抛错会让 React 卸载整棵树（白屏/重载回首页，"莫名其妙闪退"）。
 *  本边界把错误显示在屏上 + 存 localStorage，便于定位；提供"回首页"恢复。
 *  （注：事件回调/异步错误 boundary 抓不到，由 main.tsx 的全局监听兜底写 localStorage。） */
import { Component, type ReactNode } from 'react'

interface Props {
  children: ReactNode
}
interface State {
  error: Error | null
}

export default class AppErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: { componentStack?: string | null }) {
    try {
      localStorage.setItem(
        'aie_last_error',
        JSON.stringify({
          msg: error.message,
          stack: error.stack,
          componentStack: info.componentStack,
          at: new Date().toISOString(),
        }),
      )
    } catch {
      // localStorage 不可用则忽略
    }
  }

  reset = () => {
    this.setState({ error: null })
    window.location.href = '/'
  }

  render() {
    if (!this.state.error) return this.props.children
    return (
      <div style={{ padding: 24, fontFamily: 'monospace', fontSize: 13, color: '#333', maxWidth: 600, margin: '40px auto' }}>
        <h2 style={{ color: '#E65100' }}>😵 页面出了点问题</h2>
        <p>把下面这段截图发给开发者，能帮你定位问题：</p>
        <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all', background: '#FFF3E0', padding: 12, borderRadius: 8, maxHeight: 300, overflow: 'auto' }}>
          {this.state.error.message}
          {'\n\n'}
          {this.state.error.stack}
        </pre>
        <button
          onClick={this.reset}
          style={{ marginTop: 12, padding: '10px 20px', background: '#FF8C42', color: 'white', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer' }}
        >
          回首页
        </button>
      </div>
    )
  }
}
